/**
 * An interface used to undo css scaling applied by parent containers such as session Playback.
 */
export interface InverseScales {
  x: number;
  y: number;
}

// Many Page Insights UIs should appear the same size regardless of scaling applied by session Playback. Hence,
// the visual, frame, and zoom scaling of playback must be inversed.
// Disabled Zoom scaling for now. I believe it is responsible for making the tool tip grow too large.
export function createInverseScales(
  visualInverseScale: number,
  frameInverseScale: number,
  zoomInverseScale: number,
): InverseScales {
  const scale = visualInverseScale * frameInverseScale; //* zoomInverseScale;
  return {
    x: scale,
    y: scale,
  };
}

/**
 * An interface used to undo css scaling applied by parent containers such as session Playback.
 */
export interface ScaledOffsets {
  x: number;
  y: number;
}

/**
 * When a CSS transform is applied, the object is shrunk from all four corners yet its center remains the same.
 * This means that an element that is shrunk will have its left border farther right, top border farther down, etc.:
 *
 * Original    Shrunk
 * | |----|    |
 * | |    |    |  |  |
 * | |----|    |
 *
 * Hence, we need to add that offset when determining the left, top, etc. value of the object. Half of the offset is
 * lost on the left side, the right, etc. Hence, the offset is divided by 2.
 */
export function createScaledOffsets(
  height: number,
  width: number,
  inverseScales: InverseScales,
): ScaledOffsets {
  const originalWidth = width / inverseScales.x;
  const scaledWidthOffset = (originalWidth - width) / 2;
  const originalHeight = height / inverseScales.y;
  const scaledHeightOffset = (originalHeight - height) / 2;
  return {
    x: scaledWidthOffset,
    y: scaledHeightOffset,
  };
}
